import React, { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { API_URL, SESSION_MANAGER_API_URL, WORKFLOW_FILTER } from "../ConstVariable";
import axios from "axios";

function LogoutButton() {
    const { isAuthenticated, logout, getAccessTokenSilently } = useAuth0();

    const GetAuthToken = async () => {
        const token = await getAccessTokenSilently();
        return token;
    };

    const [hasLogout, setHasLogout] = useState(false);

    const state = useSelector((state) => state);

    const operatorDetails = async () => {
        const token = await GetAuthToken();

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", `Bearer ${token}`);
        let data = {
            operator_id: state.operatorEmail,
            event: "LOGOUT_OPERATOR",
        };
        // console.log(
        //   "OperatorDetails REDUX STATE in LOGOUT****  ",
        //   state.operatorEmail
        // );
        var raw;
        raw = JSON.stringify(data);

        var requestOptions = {
            method: "POST",

            headers: myHeaders,
            body: raw,
            redirect: "follow",
            credentials: "include"
        };

        fetch(`${API_URL}/oi/api/v1/watch-list`, requestOptions)
            .then((response) => response.json())
            .then((data) => {
                // console.log("OperatorDetails CURRENT LOGOUT OPERATOR ", data);
            })
            .catch((error) => {
                console.log("OperatorDetails ERROR  IN LogouT", error.message);
                // this.props.SetErrorForDisplay({
                //   severity: "warning",
                //   message: error.message,
                // });
            });
    };

    const LogoutFunc = () => {
        logout({ returnTo: window.location.origin });
    };

    const deleteSession=async()=>{
    const token = await GetAuthToken();
    axios({
      method: "DELETE",
      url: `${SESSION_MANAGER_API_URL}/session/v1/remove`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`,
      },
      timeout: 10000,
      withCredentials: true
    })
    }
    const Logout = () => {
        operatorDetails();
        setTimeout(() => {
            deleteSession()
            LogoutFunc();
        }, 1000);
    };

    return (
        isAuthenticated && (
            <Button variant="danger" onClick={Logout}>
                Logout
            </Button>
        )
    );
}

export default LogoutButton;